import React from "react";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router";
import useAuth from "../../hooks/useAuth";

const Booking = () => {
  const { serviceId } = useParams();
  const [service, setService] = useState({});
  useEffect(() => {
    fetch(`https://ancient-harbor-24674.herokuapp.com/services/${serviceId}`)
      .then((res) => res.json())
      .then((data) => setService(data));
  }, []);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const { user } = useAuth();
  const onSubmit = (data) => {
    fetch("https://ancient-harbor-24674.herokuapp.com/orders", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.insertedId) {
          alert("Order processed successfully!");
          reset();
        }
      });
  };
  return (
    <div className="card mb-3 container mt-5">
      <div className="row g-0">
        <h1 className="mt-5">Book Us</h1>
        <hr className="w-75 mx-auto" />
        <div className="col-md-6">
          {/* <img
            src={service.img}
            className="img-fluid mt-5 border rounded"
            alt="..."
          /> */}
          <div className="m-5 p-3 container m-auto mt-5 mb-5">
            <div
              className="card h-100 mx-auto"
              style={{ "max-width": "600px" }}
            >
              <div className="row g-0  ">
                <div className="col-md-4"></div>
                <Card.Img variant="top" src={service.img} />
                <Card.Body>
                  <Card.Title>
                    <h1>{service.name}</h1>
                  </Card.Title>
                  <Card.Text>{service.description}</Card.Text>
                </Card.Body>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card-body">
            <form className="mt-5" onSubmit={handleSubmit(onSubmit)}>
              <h1 className="mb-3">Thanks for booking </h1>
              <input
                className="mt-3 w-75 col-md-12 p-2"
                defaultValue={service.name}
                {...register("place")}
              />
              <br />
              <input
                className="mt-3 w-75 col-md-12 p-2"
                defaultValue={service.price}
                {...register("price")}
              />
              <br />
              <input
                className="mt-3 w-75 col-md-12 p-2"
                defaultValue={service.days}
                {...register("days")}
              />
              <br />
              <input
                className="mt-3 w-75 col-md-12 p-2"
                defaultValue={user.displayName}
                {...register("name")}
              />
              <br />
              <input
                className="mt-3 w-75 col-md-12 p-2"
                defaultValue={user.email}
                {...register("email", { required: true })}
              />
              <br />
              {errors.email && (
                <span className="error">This field is required</span>
              )}
              <input
                required
                className="mt-3 w-75 col-md-12 p-2"
                placeholder="Address"
                defaultValue=""
                {...register("address")}
              />
              <br />
              <input
                required
                className="mt-3 w-75 col-md-12 p-2"
                placeholder="City"
                defaultValue=""
                {...register("city")}
              />
              <br />
              <input
                required
                className="mt-3 w-75 col-md-12 p-2"
                placeholder="phone number"
                defaultValue=""
                {...register("phone")}
              />
              <br />
              <button className="btn btn-success mt-3 mb-3">Place Order</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
